import LocationActionTypes from '../../Actions/Location/ActionTypes';

export const LocationReducer = (state = [], action) => {
    switch (action.type) {
        case LocationActionTypes.FETCH_LOCATIONS:
            return action.payload;

        case LocationActionTypes.FETCH_LOCATION:
            return [...state.filter(item => item.id !== action.payload.id), action.payload]
        // return [...state, action.payload];

        case LocationActionTypes.ADD_LOCATION:
            return [...state, action.payload];

        case LocationActionTypes.EDIT_LOCATION:
            return state.map(item => item.id !== action.payload.id ? item : action.payload);

        case LocationActionTypes.ENABLE_LOCATION:
            return state.map(item => item.id !== action.payload.id ? item : action.payload);

        case LocationActionTypes.DISABLE_LOCATION:
            return state.map(item => item.id !== action.payload.id ? item : action.payload);

        case LocationActionTypes.DELETE_LOCATION:
            return [...state.filter(item => item !== action.payload)];

        default:
            return state;
    }
}